(function($) {
    $(document).ready( function() {
        $('.gallery-wrapper a').height($('.gallery-wrapper .main-pair').height());

        $('.alt-pairs').each( function() {
            $(this).children('.img-pair:first').addClass('selected');
        });

        $('.alt-pairs .img-pair').on('click', function() {

            $(this).addClass('selected');
            $(this).siblings().removeClass('selected');

            var main = new Array();
            $(this).parent().siblings('.main-pair').children('img').each( function() {
                main.push(this);
            });

            var current = new Array();
            $(this).children('img').each( function(index) {
                current.push(this);
            });

            var closest = $(this).parent().siblings('.main-pair');

            $(main[0]).detach();
            $(main[1]).detach();
            $(current[0]).clone().appendTo(closest);
            $(current[1]).clone().appendTo(closest);
        });

        /* load footerPosition function */
        footerPosition();
    } );

    /* footer position */
    var footerPosition = function () {
        var bodyHeight = $('body').height(),
            windowHeight = $(window).height(),
            footer = $('footer');
        if(windowHeight > bodyHeight){
            footer.css({
                'position': 'absolute',
                'bottom':'0',
                'width': '100%'
            })
        }
        $(window).on('resize',function () {
            var contentHeight = bodyHeight - (footer.height()),
                windowResizedHeight = $(window).height(),
                footerTopPos = windowResizedHeight - (footer.height());
            if(contentHeight > footerTopPos){
                footer.css({
                    'position': 'relative',
                    'bottom':'0',
                    'width': '100%'
                })
            }else{
                footer.css({
                    'position': 'absolute',
                    'bottom':'0',
                    'width': '100%'
                })
            }
        })

    }
})(jQuery);